var _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArrowUp = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4233 8.35339C11.2332 7.54352 12.5273 7.49124 13.4077 8.203L13.5786 8.35535L20.0962 14.8739C20.1894 14.9672 20.1906 15.1263 20.1001 15.2216C20.035 15.2789 19.9682 15.2996 19.9204 15.2997C19.8559 15.2997 19.7949 15.2777 19.7436 15.2264L13.2231 8.70593C12.548 8.03126 11.452 8.03125 10.7768 8.70593L4.25632 15.2264C4.16161 15.3211 3.99851 15.321 3.90378 15.2264C3.80907 15.1317 3.80912 14.9687 3.90378 14.8739L10.4233 8.35339Z",
    fill: "#455CC7",
    stroke: "#455CC7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-up.cd1336f0.svg";
export { ForwardRef as ReactComponent };